import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

const root = ReactDOM.createRoot(document.getElementById('root'));

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  integrations: [new BrowserTracing()],
  tracesSampleRate: process.env.NODE_ENV === "production" ? 1.0 : 0.1,
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

